export enum ReservationDriverAssignOption {
    AssignFamily = "assign_family",
    AssignGuest = "assign_guest",
    InviteGuest = "invite_guest",
}
